import styled from 'styled-components';

import { Flex } from '@/components/base';

const Style = styled.section`
  width: 400px;
  /* min-height: 30px; */
  padding: 24px 32px;
  overflow: hidden;
`;

const ItemWrapper = styled(Flex)`
  border: 1px solid ${(props) => props.theme.colors.gray400};
  border-radius: 5px;
  padding: 8px 10px;
`;

const PreviewStyle = {
  Style,
  ItemWrapper,
};

export default PreviewStyle;
